import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { Contract } from './contract.model';
import { Convention } from './convention.model';

export class Company extends BitfStrapiModel {
  name: string;
  contracts: Contract[];
  conventions: Convention[];

  constructor(data: Partial<Company> = {}) {
    super({ data });

    if (data.conventions) {
      this.conventions = data.conventions.map(convention => new Convention(convention));
    }

    if (data.contracts) {
      this.contracts = data.contracts.map(contract => new Contract(contract));
    }
  }

  get serialised() {
    return {};
  }
}
